'use strict';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Actions } from 'contact/state';
import { reduxForm } from 'redux-form';
import TextField from 'forms/textField';
import Checkbox from 'forms/checkbox';
import yup from 'yup';

@reduxForm({
    form: 'contact_form',
    fields: ['name', 'email', 'phone', 'message'],
    asyncValidate(data) {
        let validation = {
            name: yup.string().required('Bitte geben Sie Ihren Namen an'),
            email: yup.string().email('Ihre E-Mail Adresse scheint nicht korrekt zu sein').required('Bitte geben Sie eine E-Mail Adresse an'),
            message: yup.string().required('Bitte geben Sie eine Nachricht ein')
        };
        var schema = yup.object().shape(validation);
        return schema.validate(data, {abortEarly: false}).then(() => {
            return {};
        }).catch(err => {
            var allErrors = {};
            err.inner.forEach((validationError) => {
                allErrors[validationError.path] = validationError.message;
            });
            return Promise.reject(allErrors);
        });
    },
    getFormState: (state, reduxMountPoint) => state.get(reduxMountPoint).toJS()
})
@connect((state) => {
    return {
        contact: state.get('contact'),
        form: state.get('form')
    };
}, (dispatch) => {
    const actions = bindActionCreators(Actions, dispatch);
    return {actions};
})
export default class ContactTent extends React.Component {
    onSubmit(event) {
        event.preventDefault();
        this.props.handleSubmit(this.props.actions.handleSubmit)(event);
    }
    render() {

        if (this.props.contact.get('success')) {
            return(
                <div className="contact contact--tent">
                    <div className="contact__success">
                        Vielen Dank für Ihre Anfrage! <br />Wir setzten uns baldmöglist mit Ihnen in Verbindung.
                    </div>
                </div>);
        }

        let {fields: { email, name, phone, message }} = this.props;

        name.placeholder = 'Ihr Name';
        phone.placeholder = 'Ihre Telefonnummer';
        email.placeholder = 'Ihre E-Mail';
        message.placeholder = 'Bitte beschreiben Sie Ihr Event';

        return (
            <div className="contact contact--tent">
                <div className="contact__header">Anfrageformular</div>
                <form ref="contactForm" onSubmit={::this.onSubmit}>
                    <div className="steps__contact">
                        <TextField field={name} />
                        <TextField field={email} />
                        <TextField field={phone} />
                        <TextField textarea={true} field={message} />
                    </div>
                    <button disabled={this.props.contact.get('loading')} className="btn" type="submit">
                        {this.props.contact.get('loading') ? `Sende anfrage ....` : `Anfrage unverbindlich senden`}
                    </button>
                </form>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./static/app/contact/contactTent.jsx